import { createAsyncThunk } from '@reduxjs/toolkit';
import { loadProjectOrganizationChartItems } from './loadProjectOrganizationChartItems.thunk';
import { setSelectedProjectId } from 'scenes/Project/store/actions/projectActions';
import { loadProjectOrganizationChartResources } from './loadProjectOrganizationChartResources.thunk';

export const initProjectOrganizationChart = createAsyncThunk(
  'organizationCharts/initProjectOrganizationChart',
  async (projectId, { dispatch }) => {
    dispatch(setSelectedProjectId(projectId));

    await Promise.allSettled([
      dispatch(loadProjectOrganizationChartItems()),
      dispatch(loadProjectOrganizationChartResources()),
    ]);
  }
);
